import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { CompetitionPlayer } from './competition-player'
import { CompetitionPlayerSerializer } from './competition-player.serializer'

@Injectable()
export class CompetitionPlayerService extends ResourceService<CompetitionPlayer> {
  constructor(
    private http: HttpClient,
    private competitionPlayerSerializer: CompetitionPlayerSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/competition-players`,
      competitionPlayerSerializer
    )
  }
}
